import styled, { keyframes } from 'styled-components';
import { ICircularLoadingProps } from '.';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  };
  100% {
    transform: rotate(360deg);
  };
`;

export const CircularLoadingWrapper = styled.div<ICircularLoadingProps>`
  svg {
    animation: ${spin} 3s linear infinite;
    height: ${(props) => (props.size ? `${props.size}px` : '40px')};
    width: ${(props) => (props.size ? `${props.size}px` : '40px')};
    fill: none;
  };
`;
